import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import CareerGuidance from '../CareerGuidance/CareerGuidance'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Career Guidance & Placement Assistance" />
                <CareerGuidance />
                <Footer />
            </div>
        </>
    )
}

export default Main